import { makeStyles } from '@rbx/ui';

const useColoredMethodStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    minWidth: '56px',
  },
  background: {
    borderRadius: '4px',
    paddingInline: '4px',
    backgroundColor:
      theme.palette.mode === 'dark' ? theme.palette.surface[400] : theme.palette.states.hover,
    textAlign: 'center',
    fontWeight: 400,
  },
  get: {
    color: theme.palette.components.inlineCode.asLink.color,
  },
  put: {
    color: theme.palette.actionV2.notice.fill,
  },
  post: {
    color: theme.palette.actionV2.active.fill,
  },
  delete: {
    color: theme.palette.components.input.outlined.errorBorder,
  },
  options: {
    color: theme.palette.actionV2.primary.fill,
  },
  head: {
    color: theme.palette.actionV2.primary.fill,
  },
  patch: {
    color: theme.palette.actionV2.notice.fill,
  },
  trace: {
    color: theme.palette.actionV2.primary.fill,
  },
}));

export default useColoredMethodStyles;
